import * as React from 'react';
import styles from './FeaturesLayout.scss';
import { State } from '~/Reducers';
import { useSelector } from 'react-redux';
import equal from 'fast-deep-equal/react';
import MainFeaturesLayout from '~/Layouts/Features/Views/MainFeaturesLayout/MainFeaturesLayout';

interface IFeaturesLayout {
    shipId: number;
}

interface IStateSelector {
    shipFeatureMap: ShipFeatureMap;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        shipFeatureMap: state.ReducerFeatures.shipFeatureMap,
    };
};

const FeaturesLayout = ({ shipId }: IFeaturesLayout) => {
    const state = useSelector<State, IStateSelector>(stateSelector, equal);
    const currentFeature = state.shipFeatureMap[shipId];

    if (!currentFeature) return null;

    return (
        <div className={styles.features}>
            {currentFeature.categories.map((categories, key) => {
                if (!categories.features.every((feature) => feature.title)) {
                    return null;
                }
                return (
                    <div className={styles.feature} key={key}>
                        <div className={styles.featureIcon} style={{ backgroundImage: `url(${categories.category.icons.default})` }} />
                        <div className={styles.featureContent}>
                            <div className={styles.featureTitle}>{categories.category.title}</div>
                            <MainFeaturesLayout features={categories.features} className={styles.featureLine} circleSize={styles.featureCircle} detailedFeatures={true} />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default FeaturesLayout;
